import { render, staticRenderFns } from "./ResultAddRecommendation.vue?vue&type=template&id=313b15e7"
import script from "./ResultAddRecommendation.vue?vue&type=script&lang=js"
export * from "./ResultAddRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports